import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { Row, Form, Button } from 'react-bootstrap';
import { TimerAlert } from "../../utils/swtAlert";
import { ChangeStudentPassword } from '../../utils/axios/Auth';
import { Decrypt } from "../../utils/Helper";

function ChangePassword() {

    const navigate = useNavigate();
    const [validated, setValidated] = useState(false);
    const [email, setEmail] = useState((Decrypt(sessionStorage.getItem('Email'))));
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [id, setId] = useState((Decrypt(sessionStorage.getItem('UserId'))));
    const [confirmPasswordErr, setConfirmPasswordErr] = useState('');
    const [passwordMatch, setPasswordMatch] = useState(false);

    const confirmPasswordRef = useRef();

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
        }
        else {
            changePassword();
        }
    };

    const changePassword = async () => {
        if (passwordMatch) {
            let changePasswordPayload = {
                Password: password
            }
            var changePasswordResponse = await ChangeStudentPassword(changePasswordPayload, id);
            if (changePasswordResponse.success){
                TimerAlert("Now you can login with your Email and Password", "Password changed successfully", 'success');
                sessionStorage.removeItem('Email');
                sessionStorage.removeItem('UserId');
                navigate("/login");
            }
        }
    }

    const handleConfirmPassword = (e) => {
        if (password.length && confirmPassword.length > 0) {
            if (password !== confirmPassword) {
                confirmPasswordRef.current.style.border = "1px solid red"
                confirmPasswordRef.current.style.boxShadow = "0px 0px 4px #e6707b"
                setConfirmPasswordErr("Passwords doesn't match");
                setPasswordMatch(false);
            }
    
            else {
                confirmPasswordRef.current.style.border = "1px solid green"
                confirmPasswordRef.current.style.boxShadow = "0px 0px 4px green"
                setConfirmPasswordErr("");
                setPasswordMatch(true);
            }
        }
        else {
            confirmPasswordRef.current.style.border = "1px solid lightgray"
            confirmPasswordRef.current.style.boxShadow = "none"
            setConfirmPasswordErr("");
            setPasswordMatch(false);
        }
    };

    useEffect(() => {
        handleConfirmPassword();
    }, [password, confirmPassword]);

    return (
        <div className="rootmain border-top-wide border-primary d-flex flex-column theme-light">
            <div className='page page-center'>
                <div className='container-tight py-4'>
                    <div className='text-center mb-4'>
                        <a href="#" className='navbar-brand navbar-brand-autodark'>
                            <img src={require('../../images/grok pvt ltd logo.png')} className='img-fluid' width={200} />
                        </a>
                    </div>
                    <Form className='card card-md' noValidate validated={validated} onSubmit={handleSubmit}>
                        <div className='card-body'>
                            <h3 className='card-title text-center mb-2'>Change Password</h3><hr />
                            <Row className="mb-2">
                                <Form.Group className="mb-2" controlId="formBasicEmail">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control type="email" placeholder="Enter email" value={email} onChange={(e) => setEmail(e.target.value)} required readOnly/>
                                    <Form.Control.Feedback type="invalid"> Email is required</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="mb-2" controlId="formBasicPassword">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required/>
                                    <Form.Control.Feedback type="invalid">Password is required</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Confirm Password</Form.Label>
                                    <Form.Control ref={confirmPasswordRef} type="password" placeholder="Password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required/>
                                    {passwordMatch && <span style={{ color: 'green' }}>Passwords Match</span>}
                                    {!passwordMatch && <span style={{ color: 'red' }}>{confirmPasswordErr}</span>}
                                    <Form.Control.Feedback type="invalid">ConfirmPassword is required</Form.Control.Feedback>
                                </Form.Group>
                            </Row>
                            <Row className="mb-2">
                                <Form.Group className="login-btn mb-3">
                                    <Button className="btn btn-primary" type='submit' style={{ width: "100%", backgroundColor: "#ff0080" }}> Submit</Button>
                                </Form.Group>
                            </Row>
                        </div>
                    
                    </Form>
                </div>
            </div>
        </div>
    );
}

export default ChangePassword;